/*
 * Config Module
 *
 * Description:
 * This module will be used primarily to get and set global variables
 *
 * Purpose: 
 * Instead of accessing global variables by means of window object, this will be used as interface.
 * In case we want to change the way we access variables, we just changed this one file and it will be
 * reflected in the entire application
 * 
 * Inputs
 * options: Initialize module with some parameters
 * 	returnValue: Default return value in case parameter does not exist
 * 	accessFrom: Object Variable from which value needs to be accessed. Default is the window object
 * 
 * Outputs
 * get: Get the value requested. Null if value does not exist
 * set: Set the value on the object. Returns object
 * 
 * @authors: Chiran Doshi and Elton Jain
 */

define('Config',['jquery'], function($) {
	'use strict';

	var o,
		defaultConfig = {
			status_code: {
				no_auth_login: 'no_auth_login',
				no_auth_group: 'no_auth_group'
			},
			limits: {
				activity_limit: 6,
				notification_limit: 6,
				report_limit: 5
			}
		},

		config,

		/**
		 * [get function gets the parameter value]
		 *
		 * @param  String param [name of the parameter, can be in a tree form eg param.param1.param2]
		 *
		 * @return type depends on the field requested       [value requested]
		 */
		get = function(param) {
			var nestParam,
				cloneConfig = $.extend({}, config), // Config need to be clone to prevent it being overwritten
				k;

			param = param.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
			param = param.replace(/^\./, ''); // strip a leading dot
			nestParam = param.split('.');

			for (var i = 0, n = nestParam.length; i < n; ++i) {
				k = nestParam[i];
				if (k in cloneConfig) {
					cloneConfig = cloneConfig[k];
				} else {
					return null;
				}
			}

			return cloneConfig;
		},

		/**
		 * [set function sets the value in the cloneConfig variable]
		 *
		 * @param String param [name of the parameter. Can be in tree form e.g. param.param1.param2]
		 * @param value [value of the param]
		 */
		set = function(param, value) {
			var nestParam,
				cloneConfig = $.extend({}, config), // Config need to be clone to prevent it being overwritten
				k;

			cloneConfig = $.extend({}, config);

			param = param.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
			param = param.replace(/^\./, ''); // strip a leading dot
			nestParam = param.split('.');

			for (var i = 0, n = nestParam.length; i < n - 1; ++i) {
				k = nestParam[i];

				if (!(k in cloneConfig)) {
					cloneConfig[k] = {};
					Config[k] = {};
				}

				cloneConfig = cloneConfig[k];
			}

			cloneConfig[nestParam[n - 1]] = value;

			config = cloneConfig;

			return true;
		},

		/**
		 * [init function initializes Config variable that stores global variable accessible from all modules]
		 *
		 * @param  Object data [data that needs to be accessed from all modules]
		 *
		 */
		init = function(data) {
			if (data !== undefined) {
				config = $.extend(defaultConfig, data);
			} else {
				config = $.extend({},defaultConfig);
			}
		};

	return {
		init: init,
		get: get,
		set: set
	};
});
